import React from 'react'
import ETesting from 'src/modules/ETesting'

const ETestingPage = () => {
  return <ETesting />
}
export default ETestingPage
